const invoiceStatus = {
  DRAFT: 'Rascunho',
  ISSUING: 'Emitindo NF e Boleto',
  OPEN: 'Em aberto',
  PAID: 'Paga',
  CANCELED: 'Cancelada',
  OVERDUE: 'Em atraso',
  PROTESTED: 'Protestado'
};

module.exports = invoiceStatus;
